import { memo, useMemo } from "react";

import { FeatureIslandContainer } from "@/components/features/_layouts";

import { useInitialized } from "../../../model/neppan/use-case";
import { SettingsSiteControllerHeader, ReferenceArticles } from "../_shared";
import { REFERENCE_ARTICLES } from "./constants";
import { useSettingsSiteControllerNeppan } from "./hooks";
import { SettingsSiteControllerNeppanMain } from "./main";

import type { SiteControllerSettingBaseFormModel } from "../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../model/base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
	resetViewModel: () => void;
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;
};

export const SettingsSiteControllerNeppan = memo(
	({
		viewModel: baseViewModel,
		onSetViewModel, //
		resetViewModel,
		siteControllerSettingBaseFormModelMethodsType,
	}: Props) => {
		const { neppanViewModel, siteControllerSettingNeppanFormModelMethods } = useInitialized({
			viewModel: baseViewModel,
			onSetViewModel,
		});

		const { onUpdate } = useSettingsSiteControllerNeppan({
			viewModel: neppanViewModel,
			onResetViewModel: resetViewModel,
		});

		const isValid = useMemo(
			() => baseViewModel.isDirty && !baseViewModel.hasError,
			[baseViewModel.hasError, baseViewModel.isDirty],
		);

		return (
			<FeatureIslandContainer>
				<SettingsSiteControllerHeader onUpdate={onUpdate} isValid={isValid} />

				<ReferenceArticles articles={REFERENCE_ARTICLES} />

				<SettingsSiteControllerNeppanMain
					hotelID={baseViewModel.hotelID}
					baseViewModel={baseViewModel}
					siteControllerSettingBaseFormModelMethodsType={siteControllerSettingBaseFormModelMethodsType}
					neppanViewModel={neppanViewModel}
					siteControllerSettingNeppanFormModelMethodsType={{ siteControllerSettingNeppanFormModelMethods }}
				/>
			</FeatureIslandContainer>
		);
	},
);

SettingsSiteControllerNeppan.displayName = "SettingsSiteControllerNeppan";
